import React, { useState, useEffect, useRef } from "react";
import commonfunction from "../utilities/commonFunction";
import useAuth from "../hooks/useAuth";
import axiosInstance from '../utilities/axiosInstance';
import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from '@mui/material';
import { showAlert } from "../components/AlertPopup";
import CustomListBox from "../components/CustomListBox";
import { DOMAIN } from "../Constant";
import { io } from "socket.io-client";

const CreateTask = () => {
  const [currentDate, setCurrentDate] = useState("");
  const { auth } = useAuth();
  const defaultFormData = {
    taskTitle: "",
    taskId: "",
    status: "To do",
    assignedProject: "",
    assignedTo: "",
    reviewer_profile_id: "",
    role: 3,
    creationDate: "",
    mediaType: "",
    category: "",
  };

  const [formData, setFormData] = useState(defaultFormData);
  const [files, setFiles] = useState([]);
  const [taggers, setTaggers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [durationInSeconds, setDurationInSeconds] = useState(0);
  const [numFrames, setNumFrames] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tooltip1Visible, setTooltip1Visible] = useState(false);
  const [tooltip2Visible, setTooltip2Visible] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const inputFileRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("idle");
  const [jobId, setJobId] = useState(null);
  let socket;

  const handleIconClick = (tooltipNumber) => {
    if (tooltipNumber === 1) {
      setTooltip1Visible(!tooltip1Visible);
      setTooltip2Visible(false); //close other tooltip
    } else {
      setTooltip2Visible(!tooltip2Visible);
      setTooltip1Visible(false); //close other tooltip
    }
  };

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setTimeout(() => {
      setOpen(false);
    }, 500);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleFileChange = async (e) => {
    handleOpen();
    const files = Array.from(e.target.files);
    const names = files.map((file) => file.name);
    setFileNames(names);
    const allowedImageExtensions = [
      "jpg",
      "jpeg",
      "jfif",
      "pjpeg",
      "pjp",
      "png",
    ];
    const allowedDocumentExtensions = ["docx", "pdf","xlsx","xls"];
    const allowedVideoExtensions = ["mp4", "mov", "wmv", "avi", "webm"];
    const maxFileSize = 80 * 1024 * 1024; // 10 MB per file
    const totalMaxSize = 80 * 1024 * 1024; // Total max size (e.g., 10 MB)

    let totalSize = 0;
    let isValid = true;
    let isImageType = false;
    let isDocumentType = false;
    let isVideoType = false;
    let errorMessage = "";

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      // Check if the file is an image or document
      if (allowedImageExtensions.includes(fileExtension)) {
        isImageType = true;
      } else if (allowedDocumentExtensions.includes(fileExtension)) {
        isDocumentType = true;
      } else if (allowedVideoExtensions.includes(fileExtension)) {
        isVideoType = true;
      } else {
        errorMessage =
          "Only .jpg, .jpeg, .jfif, .pjpeg, .pjp, .png, and .docx files are allowed.";
        isValid = false;
        break;
      }

      // File size validation
      if (file.size > maxFileSize) {
        errorMessage = "Each file must be 70 MB or smaller.";
        isValid = false;
        setOpen(false);
        break;
      }

      // Total size validation
      totalSize += file.size;
      if (totalSize > totalMaxSize) {
        errorMessage = "Total size of all files must not exceed 70 MB.";
        isValid = false;
        setOpen(false);
        break;
      }
    }

    if (!isValid) {
      showAlert(errorMessage, "warning");
      e.target.value = "";
      setFormData((prevData) => ({ ...prevData, mediaType: "" }));
      return;
    }

    if (isImageType && isDocumentType && isVideoType) {
      showAlert(
        "You cannot upload images,documents and videos at the same time.",
        "warning"
      );
      e.target.value = "";
      setFormData((prevData) => ({ ...prevData, mediaType: "" }));
      commonfunction.unlinkfiles(formData);
      return;
    }

    // Validation for media type and file types matching
    if (isImageType && formData.mediaType && formData.mediaType !== "image") {
      showAlert(
        'Media type does not match the selected file type. Please select "Image" as media type.',
        "warning"
      );
      e.target.value = "";
      setFormData((prevData) => ({ ...prevData, mediaType: "" }));
      commonfunction.unlinkfiles(formData);
      setFormData(defaultFormData);
      setFiles([]);
      inputFileRef.current.value = null;
      return;
    } else if (
      isDocumentType &&
      formData.mediaType &&
      formData.mediaType !== "doc"
    ) {
      showAlert(
        'Media type does not match the selected file type. Please select "Document" as media type.',
        "warning"
      );
      e.target.value = "";
      setFormData((prevData) => ({ ...prevData, mediaType: "" }));
      commonfunction.unlinkfiles(formData);
      setFormData(defaultFormData);
      setFiles([]);
      inputFileRef.current.value = null;
      return;
    } else if (
      isVideoType &&
      formData.mediaType &&
      formData.mediaType !== "video"
    ) {
      showAlert(
        'Media type does not match the selected file type. Please select "Video" as media type.',
        "warning"
      );
      e.target.value = "";
      setFormData((prevData) => ({ ...prevData, mediaType: "" }));
      commonfunction.unlinkfiles(formData);
      setFormData(defaultFormData);
      setFiles([]);
      inputFileRef.current.value = null;
      return;
    }

    try {
      const formDatas = new FormData();
      let response = null;
      if (isImageType || isDocumentType) {

        for (const file of files) {
          formDatas.append("images", file);
        }

        const num1to50 = Math.floor(Math.random() * 50) + 1;
        const num51to90 = Math.floor(Math.random() * 40) + 51;
        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        setShowProgressBar(true);
        response = await axiosInstance.post(`/upload-new`, formDatas, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: async (progressEvent) => {
            if (progressEvent.lengthComputable) {
              setUploadStatus("uploading");
              // setProgress(num1to50);
              // console.log("num1to50======>", num1to50);
              // await sleep(500);
              // setProgress(num51to90);
              // console.log("num51to90======>", num51to90);
              // await sleep(500);
              setUploadStatus("processing");
              let percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              if (percent > 90) {
                console.log(progressEvent.loaded + ' - ' + progressEvent.total + ' - ' + progressEvent.lengthComputable);
                setProgress(90);
              }
            }
          },

        });


      } else if (isVideoType) {
        for (const file of files) {
          formDatas.append("videos", file);
        }

        response = await axiosInstance.post(`/videoupload`, formDatas, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (response.status === 200) {
        setUploadStatus("done");
        setProgress(100);
        setDurationInSeconds(response.data.durationInSeconds);
        setNumFrames(response.data.numFrames);
        setFormData({
          ...formData,
          fileName: response.data.fileName,
          filePath: response.data.filePath,
          outputDir: response.data.outputDir,
          numFrames: response.data.numFrames,
          durationInSeconds: response.data.durationInSeconds,
          dimensions: response.data.dimensions,
          originalNames: response.data.originalNames,
        });

        handleClose();
      } else {
        console.error("File upload failed");
        showAlert("File upload failed", "error");
        handleClose();
      }
    } catch (error) {
      console.error("File upload error:", error);
      showAlert("File upload error", "error");
    }

    setFiles(files);
  };

  const handleChange = (e) => {
    const { name, value, options } = e.target;
    let taggerVal;
    if (e.target.multiple) {
      taggerVal = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else {
      taggerVal = value;
    }

    // Validate media type selection based on existing files
    if (name === "mediaType" && files.length > 0) {
      const fileExtension = files[0].name.split(".").pop().toLowerCase();
      const allowedImageExtensions = [
        "jpg",
        "jpeg",
        "jfif",
        "pjpeg",
        "pjp",
        "png",
      ];
      const allowedDocumentExtensions = ["docx", "pdf","xlsx","xls"];
      const allowedVideoExtensions = ["mp4", "mov", "WMV", "AVI"];

      // Check for mismatch between selected media type and file types
      if (
        value === "image" &&
        !allowedImageExtensions.includes(fileExtension)
      ) {
        showAlert(
          'You have selected document files. Please select "Document" as media type.',
          "warning"
        );
        setFormData((prevData) => ({ ...prevData, mediaType: "" }));
        // commonfunction.unlinkfiles(formData);
        setFormData(defaultFormData);
        setFileNames([]);
        setFiles([]);
        if (inputFileRef.current) {
          inputFileRef.current.value = ""; // always use empty string
        }
        return;
      }

      if (
        value === "doc" &&
        !allowedDocumentExtensions.includes(fileExtension)
      ) {
        showAlert(
          'You have selected image files. Please select "Image" as media type.',
          "warning"
        );
        setFormData((prevData) => ({ ...prevData, mediaType: "" }));
        commonfunction.unlinkfiles(formData);
        setFormData(defaultFormData);
        setFiles([]);
        inputFileRef.current.value = "";
        return;
      }

      if (
        value === "video" &&
        !allowedVideoExtensions.includes(fileExtension)
      ) {
        showAlert(
          'You have selected video files. Please select "Video" as media type.',
          "warning"
        );
        setFormData((prevData) => ({ ...prevData, mediaType: "" }));
        commonfunction.unlinkfiles(formData);
        setFormData(defaultFormData);
        setFiles([]);
        inputFileRef.current.value = null;
        return;
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: taggerVal,
    }));

    if (e.target.type === "datetime-local") {
      e.target.blur();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) { // Prevent multiple submissions
      return;
    }

    setIsSubmitting(true);

    const formDataToSend = {
      ...formData,
      status: "To Do",
    };

    try {
      const response = await axiosInstance.post(
        `/createtask`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        // Task created successfully, you can navigate or show a success message here
        showAlert(response.data.message, "success");
        setFormData(defaultFormData); // Reset the form
        setFiles([]);
        inputFileRef.current.value = null;
        setJobId(response.data.jobId);
        localStorage.setItem("jobId", response.data.jobId);

        // Tell server to join this job room
        if (socket) {
          socket.emit("joinJob", response.data.jobId);
        }
      } else {
        console.error("Task creation failed");
        showAlert(response.data.message, "info");
      }
    } catch (error) {
      showAlert(error.response.data.message, "error");
      setFormData(defaultFormData); // Reset the form
      // console.error('Error creating task:', error);
    } finally {
      setIsSubmitting(false);
      setFileNames([]);
    }
  };

  const getTaggers = () => {
    axiosInstance
      .get(`/taggerandreviewerprofiles`, {
        params: {
          role_id: 3,
        },
      })
      .then((res) => {
        const allProfiles = res.data;
        setTaggers(allProfiles);
      })
      .catch((error) => console.error(error));
  };

  const getProjects = () => {
    axiosInstance
      .get(`/specificprojects`)
      .then((res) => {
        const allProjects = res.data;
        setProjects(allProjects);
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    getTaggers();
    getProjects();
    let currentDateLimit = new Date().toJSON().slice(0, -8);
    setCurrentDate(currentDateLimit);
  }, []);


  // web socket
  // useEffect(() => {
  //   console.log("reach here");
  //   // IMPORTANT: use the backend port (3030), not 3000
  //   const socket = new WebSocket("ws://localhost:3030");

  //   socket.onopen = () => console.log("✅ Connected to WebSocket");
  //   socket.onmessage = (event) => console.log("📩 Message:", JSON.parse(event.data));
  //   socket.onerror = (err) => console.error("❌ WebSocket error", err);
  //   socket.onclose = () => console.log("🔌 WebSocket closed");

  //   return () => socket.close();
  // }, []);

  //socket.io code
  useEffect(() => {
    const socket = io(DOMAIN, {
      transports: ["websocket"],  // force only websocket
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000
    });

    socket.on("connect", () => {
      console.log("✅ Connected to server:", socket.id);
      const savedJobId = localStorage.getItem("jobId");
      if (savedJobId) {
        console.log("🔑 Rejoining job:", savedJobId);
        socket.emit("joinJob", savedJobId);
        setJobId(savedJobId); // keep state in sync
      }
    });

    socket.on("progress", (data) => {
      console.log("Received progress:", data.progress);
      setProgress(data.progress);
    });

    socket.on("connect_error", (err) => {
      console.error("Connection error:", err);
    });

    socket.on("disconnect", (reason) => {
      console.log("disconnected:", reason);
    });

    // cleanup on unmount / reload
    return () => {
      socket.disconnect();
    };
  }, []);
  return (
    <>


      <div className="border-b border-gray-d-200 dark:border-white flex justify-between">
        <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 dark:text-white">
          Welcome {" "}
          {auth.profile_name !== "null"
            ? auth.profile_name
            : auth.profile_username}{" "}
          - Create Task{" "}
        </h2>
      </div>
      <div className="max-w-[650px] mx-auto mt-11">
        <form
          onSubmit={handleSubmit}
          id="create-task"
        >
          <div className="createtask_content">
            <div>
              <span className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                Upload Files:
              </span>

              <div className="relative w-full mt-[5px] mb-[20px]">
                <div className="w-full h-[40px] flex items-center rounded-[22px] bg-white border border-gray-300 shadow-sm font-poppins text-[15px] text-gray-main overflow-hidden">

                  {/* Button on the left */}
                  <button
                    type="button"
                    onClick={() => inputFileRef.current?.click()}
                    className={`h-full w-52 ${open ? 'text-[13px]' : 'text-[15px]'} bg-deep-blue text-white px-4 font-poppins hover:bg-deep-blue focus:outline-none flex items-center justify-center gap-2`}
                  >
                    {open && <span className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full" />}
                    Choose File(s)
                  </button>

                  {/* Selected file names or Uploading... animation */}
                  <span className="pl-4 pr-5 truncate w-full text-gray-600">
                    {open ? (
                      <span className="animate-pulse text-gray-500">{uploadStatus}</span>
                    ) : (
                      fileNames.length > 0 ? fileNames.join(', ') : "No files chosen"
                    )}
                  </span>
                </div>

                {/* Hidden native input */}
                <input
                  type="file"
                  name="fileData"
                  id="fileData"
                  accept=".jpg, .jpeg, .png, .gif, .mp3, .pdf, .doc, .docx, .xlsx, .xls, .mp4, .mov, .wmv, .avi, .webm"
                  onChange={handleFileChange}
                  ref={inputFileRef}
                  multiple
                  required
                  className="hidden"
                />
              </div>

            </div>
            {showProgressBar && (
              <div className="mt-3">
                <div className="w-full bg-gray-200 rounded-full h-4">
                  <div
                    className={`h-4 rounded-full text-xs text-white text-center bg-blue-600
              }`}
                    style={{ width: `${progress}%` }}
                  >
                    {progress}%
                  </div>
                </div>
                <p className="mt-2 text-sm text-gray-600">
                  {uploadStatus === "uploading" && "Uploading file..."}
                  {uploadStatus === "processing" && "Processing (DOCX → PDF)..."}
                  {uploadStatus === "done" && "✅ Completed!"}
                  {uploadStatus === "error" && "❌ Failed"}
                </p>

              </div >
            )}
            <div className="flex gap-3">
              <div className="left-side w-1/2">
                <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Assigned To</label>
                <CustomListBox
                  name="assignedTo"
                  selectedValue={formData.assignedTo}
                  onChange={handleChange}
                  placeholder="Select"
                  options={[
                    ...taggers.map((tagger) => ({
                      label: tagger.profile_username,
                      value: tagger.profile_id,
                    })),
                  ]}
                  displayKey="label"
                  valueKey="value"
                  isMulti={numFrames > 24}
                />
              </div>
              <div className="right-side w-1/2">
                <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Assigned Project</label>
                <CustomListBox
                  name="assignedProject"
                  selectedValue={formData.assignedProject}
                  onChange={handleChange}
                  placeholder="Select"
                  options={[
                    ...projects.map((project) => ({
                      label: project.project_Name,
                      value: project.project_id,
                    })),
                  ]}
                  displayKey="label"
                  valueKey="value"
                />
              </div>
            </div>

            <div className="flex gap-3">
              <div className="left-side w-1/2 relative">
                <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle flex items-center gap-1">
                  Folder Name
                  <div className="relative">
                    <IconButton
                      className="info-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleIconClick(1);
                      }}
                      size="small"
                    >
                      <InfoIcon sx={{ color: '#11b4d1' }} />
                    </IconButton>

                    {tooltip1Visible && (
                      <div className="absolute left-6 top-1 z-10 w-[240px] bg-deep-blue text-white text-[12px] rounded-md px-3 py-2 shadow-lg">
                        Will be inserted from backend by adding unique suffix.
                      </div>
                    )}
                  </div>
                </label>

                <input
                  type="text"
                  name="category"
                  id="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                  className="w-full h-[40px] mt-[5px] mb-[20px] rounded-[22px] bg-white border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
                />
              </div>

              <div className="right-side w-1/2 relative">
                <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle flex items-center gap-1">
                  Task Title
                  <div className="relative">
                    <IconButton
                      className="info-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleIconClick(2);
                      }}
                      size="small"
                    >
                      <InfoIcon sx={{ color: '#11b4d1' }} />
                    </IconButton>

                    {tooltip2Visible && (
                      <div className="absolute left-6 top-1 z-10 w-[240px] bg-deep-blue text-white text-[12px] rounded-md px-3 py-2 shadow-lg">
                        Will be inserted from backend by adding unique suffix.
                      </div>
                    )}
                  </div>
                </label>

                <input
                  type="text"
                  name="taskTitle"
                  value={formData.taskTitle}
                  maxLength={20}
                  onChange={handleChange}
                  required
                  className="w-full h-[40px] mt-[5px] mb-[20px] rounded-[22px] bg-white border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
                />
              </div>

            </div>

            <div className="flex gap-3">
              <div className="left-side w-1/2">
                <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Creation Date</label>
                <input
                  type="datetime-local"
                  name="creationDate"
                  value={formData.creationDate}
                  onChange={handleChange}
                  min={currentDate}
                  required
                  className="w-full h-[40px] mt-[5px] mb-[20px] rounded-[22px] bg-white border border-gray-300 pl-5 pr-5 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color font-poppins text-[15px] text-gray-main"
                ></input>
              </div>
              <div className="right-side w-1/2">
                <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Media Type</label>
                <CustomListBox
                  name="mediaType"
                  selectedValue={formData.mediaType}
                  onChange={handleChange}
                  placeholder="Select value"
                  options={[
                    { label: 'Image', value: 'image' },
                    { label: 'Document', value: 'doc' },
                    { label: 'Audio', value: 'audio', disabled: true },
                    { label: 'Video', value: 'video' },
                  ]}
                  displayKey="label"
                  valueKey="value"
                />
              </div>
            </div>
          </div>
          <div className="flex justify-end">
            <button
              type="submit"
              className="w-[150px] h-[40px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white flex items-center justify-center transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
              disabled={isSubmitting}
            >
              {isSubmitting && (
                <svg
                  className="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
              )}
              Add Task
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
export default CreateTask;
